export default "__VITE_ASSET__hHOctWS6__"